import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import SubscriptionGateway from '../Components/SubscriptionGateway';
import ConfirmDialog from '../Components/ConfirmDialog';
import UserNotRegisteredDialog from '../Components/UserNotRegisteredDialog';
import Button from '@material-ui/core/Button';
import { GatewayAddIcon } from '../Assets/Icons/Sikom';

let t;
let self;

class AccountOverview extends Component {
    constructor(props) {
        super(props);
        self = this;
        t = props.t;
        this.state = {
            purchaseDialogOpen: this.props.paymentStatus !== null ? true : false,
            userNotRegisteredDialogOpen: this.props.customerIsRegistered ? false : true
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    getGatewayStyle(index, length) {
        if (length === 1) {
            return '';
        }
        return 'multiple-gateways-paper-style'
    }

    getPaymentStatusTitleText() {
        return (this.props.paymentStatus === 'OK' || this.props.paymentStatus === 'Continue') ? t('payment_successful_title') : t('payment_failed_title');
    }

    getPaymentStatusMessageText() {
        return (this.props.paymentStatus === 'OK' || this.props.paymentStatus === 'Continue') ? t('payment_successful_message') : t('payment_failed_message');
    }

    getPaymentStatusButtonText() {
        return t('ok');
    }

    onPaymentButtonClicked = e => {
        e.preventDefault();
        // Need to set payment status to null after ok, otherwise the dialog shows up each
        // time this page is opened.
        self.props.setPaymentStatus(null);
        // Hide dialog and remove the paymentStatus query string from the url
        const queryString = require('query-string');
        const parsed = queryString.parse(window.location.search);
        const query = '?language=' + self.props.language + '&valueCode=' + parsed.valueCode;
        window.history.replaceState({}, document.title, "/" + query);
        const booleanValue = (parsed.automaticLogin === 'true');
        self.props.setAutomaticLogin(booleanValue);
    }

    onAddGatewayClicked = e => {
        e.preventDefault();
        this.props.updatePage('add_gateway')
    }

    hideNotRegisteredDialog() {
        self.setState({
            userNotRegisteredDialogOpen: false
        });
    }

    componentDidMount() {
        self.props.setLoading(false);
    }

    render() {
        const data = this.props.data;
        const gateways = data.gateways;

        const addGatewayButtonContent =
            <Button
                onClick={e => this.onAddGatewayClicked(e)}
                style={addGatewayButtonStyle}
                variant="contained"
                color="primary">
                <GatewayAddIcon style={buttonIconStyle} />
                {t('add_gateway')}
            </Button >

        const gatewaysContent = gateways.map((gateway, index) =>
            <div key={index}>
                <div className='typography-title-container'>
                    <Typography variant="title">
                        {t('gateway')} {gateways.length > 1 ? (' ' + (index + 1)) : null}
                    </Typography>
                </div>
                <div className={this.getGatewayStyle(index, gateways.length)} key={gateway.bpapi_gateway_id}>
                    <SubscriptionGateway
                        updatePage={this.props.updatePage}
                        customer={this.props.customer}
                        usingValueCode={this.props.usingValueCode}
                        automaticLogin={this.props.automaticLogin}
                        setLoading={this.props.setLoading}
                        language={self.props.language}
                        simpleView={true}
                        updateAppData={this.props.updateAppData}
                        t={t}
                        credentials={this.props.credentials}
                        gateway={gateway}
                        customerIsRegistered={this.props.customerIsRegistered}
                        hasMultipleGateways={this.props.hasMultipleGateways}
                        setGatewayToBeReplaced={this.props.setGatewayToBeReplaced}
                        setShouldRenewSubscription={this.props.setShouldRenewSubscription}
                        shouldRenewSubscription={this.props.shouldRenewSubscription}
                        updatePageWithProps={this.props.updatePageWithProps}
                        logout={this.props.logout} />
                </div>
            </div>
        );
        const paymentStatusContent =
            <ConfirmDialog
                titleText={this.getPaymentStatusTitleText()}
                messageText={this.getPaymentStatusMessageText()}
                buttonText={this.getPaymentStatusButtonText()}
                onButtonClicked={e => this.onPaymentButtonClicked(e)}
                open={this.state.purchaseDialogOpen}
            />;

        const userNotRegisteredContent =
            <UserNotRegisteredDialog
                updatePage={this.props.updatePage}
                toggleDialog={this.hideNotRegisteredDialog}
                open={this.state.userNotRegisteredDialogOpen}
                t={this.props.t} />;

        let content = <div className="content-frame">
            <div className="content">
                <div className="content-container-subscription">
                    <div className='typography-title-container'>
                        {this.props.data.customer.email.includes('@') ?
                            <div>
                                <Typography style={usefulInformationStyle} variant="title">
                                    {t('sam_useful_information_title')}
                                </Typography>
                                <Typography variant="body1">
                                    {t('sam_useful_information_message')}
                                </Typography>
                                <br></br>
                                <Typography variant="title">
                                    {t('user_account')}
                                </Typography>
                                <TextField style={editTextStyle}
                                    id="email"
                                    value={this.props.data.customer.email}
                                    label={t('email')}
                                    onChange={this.handleChange('email')}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                        disableUnderline: true,
                                    }} />
                            </div>
                            :
                            null
                        }
                    </div>
                    {gatewaysContent}
                    {addGatewayButtonContent}
                    {this.props.customerIsRegistered ? null : userNotRegisteredContent}
                    {this.props.paymentStatus !== null ? paymentStatusContent : null}
                </div>
            </div>
        </div>;

        // Todo: This is ugly. Fix.
        if (this.props.isLoading) {
            content = null;
        }

        return (content);
    }
}




export default AccountOverview;

const editTextStyle = {
    width: '100%',
}

const usefulInformationStyle = {
    marginBottom: 10,
}

const buttonStyle = {
    width: '100%'
};

const addGatewayButtonStyle = {
    width: '100%',
    marginTop: 20,
    marginBottom: 20
};

const buttonIconStyle = {
    paddingRight: 10,
};









// WEBPACK FOOTER //
// ./src/Pages/AccountOverview.js